import packageJson from '../../package.json';

export const posVersion = packageJson.version;

export const localStorageKeys = {
  receiptConfig: 'Receipt Config',
  patConfig: 'PAT Config',
};
